{
  "data": {
    "email_support": "support{'@'}planfred.com",
    "phone_number": "+43 1 9974470-2"
  },
  "feature": {
    "account": {
      "billing_data": {
        "company": "Company"
      },
      "plan_selection": {
        "free": {
          "price": "£ 0"
        },
        "maxi": {
          "price_per_month": "£ 235",
          "price_per_year": "£ 2,585"
        },
        "message_testphase_end": "You can then continue your projects seamlessly!",
        "midi": {
          "price_per_month": "£ 75",
          "price_per_year": " £ 825"
        },
        "mini": {
          "price_per_month": "£ 25",
          "price_per_year": "£ 275"
        },
        "online_course": "Online training",
        "prime": {
          "price_per_month": "£ 385",
          "price_per_year": "£ 4,235"
        },
       "tax": "All prices are plus statutory VAT."
      }
    },
    "item": {
      "task_mailer": {
        "subject_prefix": "{projectTitle} - {taskTitle}"
      }
    }
  },
  "layout": {
    "footer": {
      "any_questions": "You have questions?"
    },
    "go_to_website_url": "https://{hostname}/en-gb/"
  }
}
